function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledInput } from "./UnstyledInput";

/*
    Returns a controlled text input

    props
        (string)   value     The current value of the input
        (string)   name 
        (function) onChange  The function to call when the input value changes
        (props)    rest 
*/

const UnstyledControlledInput = ({
  value = "",
  name,
  onChange = null,
  ...rest
}) => {
  const handleOnChange = e => {
    const {
      value
    } = e.target;
    onChange({
      name,
      value
    });
  };
  return /*#__PURE__*/React.createElement(UnstyledInput, _extends({
    value: value,
    name: name,
    onChange: handleOnChange
  }, rest));
};
export { UnstyledControlledInput };